module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_SKU2.0036.png.10a84ada.jpg";